<template>
  <tab-layout :actionBar="true">
    <horse-add-details :edit="edit" :register="register" :horseRegistrants="horseRegistrants" slot="tabContent" class="row mx-0 show active" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import horseAddDetails from './HorseAddDetails'

export default {
  name: 'HorseAdd',
  props: ['edit', 'register', 'horseRegistrants'],
  components: {
    'tab-layout': tabLayout,
    'horse-add-details': horseAddDetails
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Horses/Add/HorseAdd.vue